import React, {useState, useEffect} from 'react';
import Web3 from 'web3';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { CONTRACT_ADDRESS , CONTRACT_ABI } from '../config';
import { MerkleTree } from 'merkletreejs';
import keccak256 from 'keccak256';
// import whitelistAddresses from './../whitelistAddresses.json';
import Hero from "./video/hero.mp4";
import CountdownTimer from './TimeCounter/CountdownTimer';
import '../App.css';
import { DateTime } from "luxon";

const Home = () => {

	var provider;
	var web3;
	var contract;

	const [accountCoonected, setAccountCoonected] = useState(false);
	const [myWeb3, setMyWeb3] = useState(false);
	const [myContract, setMyContract] = useState(false);
	const localtime = DateTime.fromISO("2022-11-23T00:00", { zone: "America/New_York" }).toJSDate()
	const [targetDate, setTargetDate] = useState(new Date(localtime));

	const providerOptions = {
				walletconnect: {
					package: WalletConnectProvider,
					options: {
						infuraId: "3ce08274a37c411393d3736f9c94591c",
						chainId: 1,
					}
				}
	};
	let web3Modal = new Web3Modal({
				cacheProvider: false,
				providerOptions, 
	}); 

	async function handleAccounts()
	{
		
		console.log("Opening a dialog", web3Modal);
		provider = await web3Modal.connect();

		provider.on("accountsChanged", (accounts) => {
							// alert('1');
								init2();
								
							})
		
			provider.on("networkChanged", (networkId) => {
				// alert('2');
					init2();
			});

			await init2();
			
	}

	async function init2() {
		web3 = new Web3(provider);
		setMyWeb3(web3);
		contract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);
		setMyContract(contract);
		web3.eth.getAccounts(function(err, accounts) {
				if (web3.currentProvider.chainId != 1) {
						alert('connect your wallet with Ethereum main net');
						let userAddress = accounts[0];
						// alert(accounts[0]);
				}
				else
				{
					setAccountCoonected(true);
				}

		});
	}

	useEffect(() => {
		handleAccounts();
	}, []);

	const openMetaMask = async (mintAmount) => {
		//handleAccounts();
		// web3 = new Web3(provider);
		let accounts = await myWeb3.eth.getAccounts();
		let selectedAccountCustom = accounts[0];
		let Cost = await myContract.methods.cost().call();
		let isWhiteListEnabled = await myContract.methods.onlyWhitelisted().call();
		//let mintAmount = 1;
		if(isWhiteListEnabled)
			{
				myContract.methods.mint(mintAmount).estimateGas({from: selectedAccountCustom, value: Cost * mintAmount}).then(function(gasAmount){
					myContract.methods.mint(mintAmount)
						.send({ 
							from: selectedAccountCustom ,
							value: Cost * mintAmount
							//value: web3.utils.toWei((cost * amount).toString() , "ether")
							});
				});

		}
		else
		{
			myContract.methods.mint(mintAmount).estimateGas({from: selectedAccountCustom, value: Cost * mintAmount}).then(function(gasAmount){
					myContract.methods.mint(mintAmount)
						.send({ 
							from: selectedAccountCustom ,
							value: Cost * mintAmount
							//value: web3.utils.toWei((cost * amount).toString() , "ether")
							});
				});
		}
	}

	const handleMint = (event) => {
		event.preventDefault();
		const { amount } = event.target.elements;
		if(amount.value > 5)
		{
			return alert("Please mint less than 5 nfts at a time");
		}
		if(amount.value < 1)
		{
			return alert("Please mint at least 1 nft");
		}
		if(isNaN(amount.value))
		{
			return alert("Please enter number only");
		}
		if(amount.value == '')
		{
			return alert("Please enter number");
		}

		openMetaMask(amount.value);
	}

	return ( 
		<>
			<div className="home_banner" id="home">
				<div className="home_banner_position">
						{/* <video src="images/hero.mp4" className="vid-bg" autoplay loop muted=""></video> */}
					<video autoPlay loop muted className="vid-bg">
							<source src={ Hero } type="video/mp4"/>
					</video>
						<div className="home_banner_text aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
							<h3>WELCOME TO<br/> <em>UNIVERSAL SPACE</em> <br/>STATION.</h3>
							<div className="btn_flex">
								<div className="btn_flex_inner connect-wallet">
									{/* {accountCoonected && <button className='btn' onClick={openMetaMask}>Mint NFT</button>} */}
										{
											accountCoonected 
											&& 
											<form onSubmit={handleMint}>
												<input type="number" name="amount" id="amount" placeholder="1" /> 
												<button type="submit" className='btn'>Mint NFT</button>
											</form>
										}
										{!accountCoonected && <button className='btn' style={{marginBottom: '20px'}} onClick={handleAccounts}>Connect Wallet</button>}		
										{/* <CountdownTimer targetDate={targetDate} />				 */}
								</div>
							</div>
						</div>
				</div>
			</div>
			{/* <!--For Mobile--> */}
			<div className="mob_home_banner" id="mob_home">
				<div className="mob_home_banner_position">
						<div className="home_banner_text aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
							<h3>WELCOME TO<br/> <em>UNIVERSAL SPACE</em> <br/>STATION.</h3>
							<div className="btn_flex">
								<div className="btn_flex_inner">
									{
											accountCoonected 
											&& 
											<form onSubmit={handleMint}>
												<input type="number" name="amount" id="amount" placeholder="1" /> 
												<button type="submit" className='btn button _2nd w-button mint_btn'>Mint NFT</button>
											</form>
										}
										{!accountCoonected && <button className='btn button _2nd w-button mint_btn' onClick={handleAccounts}>Connect Wallet</button>}
										{/* <CountdownTimer targetDate={targetDate} /> */}
								</div>
							</div>
						</div>
				</div>
			</div>
		</>
	);
}
 
export default Home;